// extracted by mini-css-extract-plugin
module.exports = {"link":"GoBack_link__RU6Oc"};